import { useContext } from "react";
import { Button } from "react-bootstrap";
import { Controller, UseFormReturn } from "react-hook-form";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrderContext } from "../../../contexts/OrderContext";
import { EOrderTipForm } from "../../../services/types";
import { POSSIBLE_TIP_AMOUNTS } from "../../../utils/orderTips";

interface Props {
	form: UseFormReturn<EOrderTipForm>;
}

export const OrderTipList = ({ form }: Props) => {
	const { control } = form;
	const { currency } = useContext(OrderContext);

	return (
		<Controller
			name="tip"
			control={control}
			render={({ field: { onChange, value } }) => {
				return (
					<div className="order-tips-list" data-testid="order-tips-list">
						{POSSIBLE_TIP_AMOUNTS.map((tipAmount) => {
							if (tipAmount === 0) return null;

							const isTipSelected = tipAmount === value;
							const textToBeDisplayed =
								tipAmount === null
									? "..."
									: FormatMoney({
											amount: tipAmount,
											currency,
									  });

							return (
								<Button
									key={tipAmount}
									variant={isTipSelected ? "dark" : "outline"}
									onClick={() => onChange(tipAmount)}
									className={`bg-${isTipSelected ? "dark" : "light"}`}
								>
									{textToBeDisplayed}
								</Button>
							);
						})}
					</div>
				);
			}}
		/>
	);
};
